import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'
import { z } from 'zod'
import { UsageScreen } from '@/screens/billing/SCR-051-usage'

export const Route = createFileRoute('/_app/org/usage')({
  staticData: { screen: { id: 'SCR-051', title: 'Usage & costs', group: 'Organisation', perm: 'billing.read', order: 8, description: 'What your organisation used, by meter, day, workspace, key and member.', icon: BarChart3 } },
  validateSearch: z.object({ range: z.enum(['month', '30d', '90d']).optional(), tab: z.enum(['meters', 'workspaces', 'keys', 'members']).optional() }),
  component: function UsageRoute() {
    const s = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
      <UsageScreen
        range={s.range ?? 'month'}
        tab={s.tab ?? 'meters'}
        onRange={range => navigate({ search: prev => ({ ...prev, range }), replace: true })}
        onTab={tab => navigate({ search: prev => ({ ...prev, tab }), replace: true })}
      />
    )
  },
})
